<jhi-bary-card [titleKey]="'register.form.companyInformation.title'" *ngIf="baryForm.get('companyForm')">
  <div body>
    <div class="row" *ngIf="description">
      <div class="col-12">
        <p class="text-lead">{{ description }}</p>
      </div>
    </div>

    <ul class="striped list-unstyled" *ngIf="!editable">
      <li class="mb-1">
        <span class="font-weight-bold">{{ 'LABEL.LEGAL_STATUS' | translate }}&nbsp;:</span>
        <span data-id-cypress="user-legal-status">{{ user?.companyLegalStatus }}</span>
      </li>
      <li class="mb-1">
        <span class="font-weight-bold">{{ 'LABEL.COMPANY.NAME' | translate }}&nbsp;:</span>
        <span data-id-cypress="user-company-name">{{ user?.companyName }}</span>
      </li>
      <li class="mb-1">
        <span class="font-weight-bold">{{ 'LABEL.SIRET_NUMBER' | translate }}&nbsp;:</span>
        <span data-id-cypress="user-siret">{{ user?.siret }}</span>
      </li>
      <li class="mb-1">
        <span class="font-weight-bold">{{ 'LABEL.VAT_NUMBER' | translate }}&nbsp;:</span>
        <span data-id-cypress="user-vat-number">{{ user?.vatNumber }}</span>
      </li>
    </ul>
    <form autocomplete="off" *ngIf="editable">
      <div class="row">
        <div class="col-12">
          <jhi-bary-input-select
            data-id-cypress="select-status"
            [control]="getCompanyControl('companyLegalStatus')"
            [label]="'LABEL.LEGAL_STATUS' | translate"
            [id]="'company.legalStatus'"
            [options]="legalStatusOptions"
          >
          </jhi-bary-input-select>
        </div>
        <div class="col-12">
          <jhi-bary-input-text
            data-id-cypress="organisation-name"
            [control]="getCompanyControl('companyName')"
            [id]="'company.name'"
            [label]="'LABEL.COMPANY.NAME' | translate"
          ></jhi-bary-input-text>
        </div>
        <div class="col-12">
          <jhi-bary-siret
            data-id-cypress="siret"
            [control]="getCompanyControl('siret')"
            [autoSearch]="false"
            [searchButton]="false"
            (siretChange)="getCompanyControl('siret').setValue($event)"
            [id]="'company.siret'"
          ></jhi-bary-siret>
        </div>
        <div class="col-12">
          <jhi-bary-input-text
            data-id-cypress="vat-number"
            [control]="getCompanyControl('vatNumber')"
            [id]="'company.vatNumber'"
            [label]="'LABEL.SIRET_NUMBER' | translate"
          >
          </jhi-bary-input-text>
        </div>
      </div>
    </form>
  </div>
  <mdb-card-footer footer class="bg-white text-right" *ngIf="switchButton">
      <jhi-bary-button *ngIf="!editable" [label]="'BTN.MODIFY' | translate" icon="pen" color="primary" (click)="editable=true"></jhi-bary-button>
      <jhi-bary-button *ngIf="editable" [label]="'BTN.CANCEL' | translate" icon="times" color="danger" (click)="editable=false; saveEvent.emit(false)"></jhi-bary-button>
      <jhi-bary-button *ngIf="editable" [label]="'BTN.SAVE' | translate" icon="save" color="primary" (click)="editable=false; saveEvent.emit(true)" [disabled]="companyForm.invalid"></jhi-bary-button>
    </mdb-card-footer>
</jhi-bary-card>
